<template>
    <div class="sidebar-app">
        <div class="p-sidebar-mask p-sidebar-visible p-sidebar-left app-sidebar-style">
            <div 
                class="p-sidebar p-component p-ripple-disabled app-sidebar">
                <div class="flex align-items-center p-2">
                    <a
                        v-ripple
                        v-styleclass="{
                            selector: '@next',
                            enterClass: 'hidden',
                            enterActiveClass: 'slidedown',
                            leaveToClass: 'hidden',
                            leaveActiveClass: 'slideup'
                        }"
                        class=
                            "
                                flex align-items-center justify-content-between
                                cursor-pointer p-3 border-round
                                transition-duration-150 
                                transition-colors p-ripple
                                user-profil w-full
                            "
                    >
                        <div class="flex align-items-center ">
                            <img 
                                src="https://cdn.create.vista.com/api/media/small/295488734/stock-photo-modern-african-american-ceo-portrait-standing-confidently-arms-crossed-swanky" 
                                alt=""
                                class="avatar mr-3"
                            >
                            <span class="font-medium">Amy Elsner</span>
                        </div>
                        <button @click="logout" class="w-full p-link flex align-items-center ml-4 p-2 pl-4 text-color hover:surface-200 border-noround">
                            <span class="material-icons icon-class pr-2">logout</span>
                        </button>
                    </a>
                </div>
                <span  class="p-hidden-accessible p-hidden-focusable"></span>
                <div class="flex flex-column h-full">
                    <div class="overflow-y-auto">
                        <ul class="list-none p-3 m-0 overflow-hidden">
                            <li v-for="(menu, index) in menus" :key="index">
                                <navlink
                                    :title="menu.titleMenu"
                                    :link="menu.link"
                                    :icon="menu.icon"
                                    :subMenus="menu.subMenus"
                                    :showmenu="showmenu"
                                    :isOpen="isOpen"
                                />
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- <div class="" style="background-color: red;">
                    ceci
                </div> -->
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import navlink from './nav-link/navlink.vue';
import { useAuthStore } from "@/store/modules/auth";
export default defineComponent({
    name: "SidebarApp",
    components: {   
        navlink
    },
    props: ["menus", "showmenu", "isOpen"],
    data(){
        return{
            visible: true,
            fixed: true,
            showside: true,
            authStore: useAuthStore(),
        }
    },
    computed: {
        
    },
    methods:{
        toggleSidebar(){
            this.showside = !this.showside
        },
        logout(){
            this.authStore.logout();
        }
    },
})
</script>
<style>
.p-sidebar-left .app-sidebar.p-sidebar {
    white-space: nowrap;
    width: 80px;
    height: 100%;
    transition: width .6s ease-in-out;
    box-shadow: none!important;
    background-color: var(--sidebar-orch-background-color);
    border: none;
}
.p-sidebar-left .app-sidebar.p-sidebar:hover {
    white-space: nowrap;
    width: 300px;
    height: 100%;
    transition: width .6s ease-in-out;
}
.p-sidebar-left .app-sidebar-fixed.p-sidebar {
    white-space: nowrap;
    width: 300px;
    height: 100%;
    transition: width .6s ease-in-out;
}
.app-sidebar-style {
    position: static;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.user-profil span{
    color: #fff;
}
</style>
<style src="./sidebar-app.scss" lang="scss" scoped/>  